import React, { Fragment } from 'react';

import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { isNil, includes } from 'ramda';
import emoji from 'emoji-dictionary';
import { Box, Typography } from '@material-ui/core';

import MortgageSurveyPresenter, { PURPOSE_TYPES } from 'presenters/MortgageSurveyPresenter';
import LoanOfficerPresenter from 'presenters/LoanOfficerPresenter';
import MortgageSurvey from 'sharedComponents/MortgageSurvey';
import MortgageSurveyFlowSelect from 'sharedComponents/MortgageSurveyFlowSelect';
import { loanOfficersRefinanceSurvey, loanOfficersPurchaseSurvey } from 'lib/surveys';

import useStyles from './useStyles';

const Survey = props => {
  const { onSelectFlow, selectedFlow, surveyValues, setInitialSurveyValues, loanOfficer } = props;
  const classes = useStyles();
  const { t } = useTranslation();

  const handleSelectFlow = value => {
    const initialValues = MortgageSurveyPresenter.buildInitialSurveyFlowValues(surveyValues, value);
    setInitialSurveyValues(initialValues);
    onSelectFlow(value);
  };

  const isNeedToSelectFlow = isNil(selectedFlow);

  if (isNeedToSelectFlow) {
    return (
      <Box className={classes.container}>
        <MortgageSurveyFlowSelect
          onSelect={handleSelectFlow}
          rowComponent={
            <Fragment>
              <div className={classes.header}>
                <div className={classes.emoji}>{emoji.getUnicode('tada')}</div>
                <Typography variant="h1" className={classes.header}>
                  {t('components.BuyerLoanOfficerSearchSurvey.SurveyPage.Survey.header')}
                </Typography>
              </div>
              <Box mt={2} />
              <Typography variant="body1" className={classes.description}>
                {t('components.BuyerLoanOfficerSearchSurvey.SurveyPage.Survey.description', {
                  name: LoanOfficerPresenter.firstName(loanOfficer),
                })}
              </Typography>
              <Box mt={2} />
              <Typography variant="body1" className={classes.additionalDescription}>
                {t('components.BuyerLoanOfficerSearchSurvey.SurveyPage.Survey.additionalDescription')}
              </Typography>
              <Box mt={2} />
            </Fragment>
          }
        />
      </Box>
    );
  }

  const { questions } = includes(selectedFlow, PURPOSE_TYPES.refinance)
    ? loanOfficersRefinanceSurvey
    : loanOfficersPurchaseSurvey;

  return <MortgageSurvey questions={questions} />;
};

Survey.propTypes = {
  onSelectFlow: PropTypes.func.isRequired,
  selectedFlow: PropTypes.string,
  surveyValues: MortgageSurveyPresenter.shape().isRequired,
  setInitialSurveyValues: PropTypes.func.isRequired,
  loanOfficer: LoanOfficerPresenter.shape(),
};

Survey.defaultProps = {
  selectedFlow: null,
  loanOfficer: {},
};

export default Survey;



// WEBPACK FOOTER //
// ./src/components/BuyerLoanOfficerSearchSurvey/components/SurveyPage/components/Survey/Survey.js